import styled from "@emotion/styled";
import React from "react";

import ErrorBoundaryComponent from ".";

function PublicErrorBoundary(props: IPublicErrorBoundary) {
  return (
    <ErrorBoundaryComponent
      suspendComponent={
        <ContentWrapBg>
          <CirculeIcon>
            <img src="src/assets/images/remax-logo.png" />
          </CirculeIcon>
        </ContentWrapBg>
      }
    >
      {props?.children}
    </ErrorBoundaryComponent>
  );
}

export default PublicErrorBoundary;
interface IPublicErrorBoundary {
  children?: any;
}

const CirculeIcon = styled.div`
  display: flex;
  width: 200px;
  height: 200px;
  background-color: white;
  border-radius: 50px;
  background: var(--color-blue-main);
  justify-content: center;
  align-items: center;
`;

const ContentWrapBg = styled.div`
  display: flex;
  width: 100vw;
  height: 100vh;
  justify-content: center;
  align-items: center;
  background-image: url(src/assets/images/bg-image-beach.png);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  animation: rotate(360deg) repeat infinite 2s;
`;
